/**
 * Extrai apenas o id da mensagem referenciada ou editada.
 * @param {object|null} oMensagem Mensagem original (pode ser null)
 * @returns {object|null} Objeto com apenas o id ou null
 */
const mensagemExtrairId = (oMensagem) => {
  if (!oMensagem || !oMensagem.id) return null
  return oMensagem.id
}

export default mensagemExtrairId
